<template>
  <div class="d-flex justify-end user-actions-wrapper align-center">
    <layout-user-actions-send-homework v-if="showHomeworkButton" />
    <layout-user-actions-bookmark-button v-if="showBookmarkButton" />
    <layout-user-actions-pdf-playlist-button v-else-if="showPdfPlaylistButton" />
    <layout-user-actions-profile-menu />
  </div>
</template>

<script lang="ts">
import constants from "~/constants"
import { usePdfStore } from "~/stores/pdfStore"
import { useSmartPageStore } from "~/stores/smartPageStore"
import { useUserStore } from "~/stores/userStore"

export default {
  setup() {
    const userStore = useUserStore()
    const smartPageStore = useSmartPageStore()
    const pdfStore = usePdfStore()
    return { userStore, smartPageStore, pdfStore }
  },

  computed: {
    showHomeworkButton(): boolean {
      if (this.$route.matched.length === 0) {
        return false
      }
      const showBasedOnRoute = constants.HOMEWORK_BUTTON_PATHS.includes(this.$route.matched[0].path)
      return !this.$vuetify.display.xs && showBasedOnRoute && this.userStore.isTeacher && this.userStore.isEklaseUser
    },

    showBookmarkButton(): boolean {
      return this.$route.params.smartFileSlug !== undefined && this.smartPageStore.value !== null
    },

    showPdfPlaylistButton(): boolean {
      return this.pdfStore.currentFile
    },
  },
}
</script>

<style lang="sass">
.user-actions-wrapper
  gap: 24px
</style>
